<template>

  <div class="space-y-6">
    <p class="h1-title">一、评测结论</p>
    <p class="font-heiti"><span class="">试点企业：</span>{{info.eName}}</p>
    <p>吉林吉大通信设计院股份有限公司、吉林省电子技术研究所作为长春市工业和信息化局委托的评测机构，依据工信部《中小企业数字化水平评测指标（2024 年版）》（工信厅企业〔2024〕56 号），从数字化基础、数字化管理、数字化成效和数字化经营四个维度，综合判定该试点企业<span class="font-heiti">数字化水平等级</span>为：</p>
    <span v-if="info.scenesLevel[2]" class="text-level font-heiti" :class="['text-black', 'text-gray-level', 'text-yellow-level', 'text-blue-level', 'text-purple-level'][info.scenesLevel[2] || 0]">{{info.levelsName}}（{{info.d.levels}}）</span>
    <span v-else class="text-level font-heiti text-black">无等级</span>
    <p class="">其中，<span class="font-heiti">数字化基础、数字化管理、数字化成效</span>三个维度的<span class="font-heiti">评分</span>为：</p>
    <span class="text-sub-level text-xl font-heiti" :class="{ '无等级': 'text-black', '一级': 'text-gray-level', '二级': 'text-yellow-level', '三级': 'text-blue-level', '四级': 'text-purple-level' }[info.scoreLevel || '无等级']">{{info.d.score * 1}}（{{info.scoreLevel}}）</span>
    <p class="" style="text-indent: 5rem;"><span class="font-heiti">数字化经营</span>维度的<span class="font-heiti">应用场景等级判定</span>为：</p>
    <div>
      <span class="text-sub-level text-xl font-heiti" :class="{ '无等级': 'text-black', '一级': 'text-gray-level', '二级': 'text-yellow-level', '三级': 'text-blue-level', '四级': 'text-purple-level' }[info.levelName || '无等级']">{{info.levelName}}</span>
      <span class="text-sub-level font-heiti" v-for="(str, i) in info.sceneStrArr" :key="i" :class="str.cl">{{str.content}}</span>
    </div>
    <div class="mx-auto w-4/5 border-b border-solid border-black pt-1"></div>
    <div class="font-heiti text-sm space-y-2">
      <div class="mx-auto text-center">表1 工信部《中小企业数字化水平评测指标（2024 年版）》</div>
      <div class="mx-auto text-center">中小企业数字化水平等级判定方法</div>
      <div class="grid grid-cols-6 justify-center items-center text-center border border-solid border-black font-heiti">
        <div class="col-span-6 grid grid-cols-6 justify-center items-center">
          <div class="col-span-1 bg-blue-bg h-full flex justify-center items-center border-r border-b border-solid border-black">等级</div>
          <div class="col-span-5 grid grid-cols-5 justify-center items-center bg-blue-bg border-b border-solid border-black">
            <div class="col-span-5 py-2">要求（须同时满足两部分要求）</div>
            <div class="col-span-2 flex flex-col justify-center items-center border-t border-r border-solid border-black gap-0">
              <div>数字化基础、管理及成效</div>
              <div>（评测得分）</div>
            </div>
            <div class="col-span-3 flex flex-col justify-center items-center border-t border-solid border-black">
              <div>数字化经营</div>
              <div>（应用场景等级）</div>
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col justify-center items-center bg-blue-bg border-b border-r border-solid border-black">
          <div>一级</div>
          <div>（初始级）</div>
        </div>
        <div class="col-span-2 h-full flex items-center justify-center border-r border-b border-solid border-black">≥20 分</div>
        <div class="col-span-3 h-full flex items-center justify-center border-b border-solid border-black">不少于 6 个应用场景（其中不少于 3 个约束性场景）等级需达到一级</div>
        <div class="col-span-1 flex flex-col justify-center items-center bg-blue-bg border-r border-b border-solid border-black">
          <div>二级</div>
          <div>（规范级）</div>
        </div>
        <div class="col-span-2 h-full flex items-center justify-center border-r border-b border-solid border-black gap-0">≥40 分</div>
        <div class="col-span-3 h-full flex items-center justify-center border-b border-solid border-black gap-0">不少于 6 个应用场景（其中不少于 3 个约束性场景）等级需达到二级</div>
        <div class="col-span-1 flex flex-col justify-center items-center bg-blue-bg border-r border-b border-solid border-black">
          <div>三级</div>
          <div>（集成级）</div>
        </div>
        <div class="col-span-2 h-full flex items-center justify-center border-r border-b border-solid border-black">≥60 分</div>
        <div class="col-span-3 h-full flex items-center justify-center border-b border-solid border-black">不少于 8 个应用场景（其中不少于 5 个约束性场景）等级需达到三级</div>
        <div class="col-span-1 flex flex-col justify-center items-center bg-blue-bg border-r border-solid border-black gap-0">
          <div>四级</div>
          <div>（协同级）</div>
        </div>
        <div class="col-span-2 h-full flex items-center justify-center border-r border-solid border-black gap-0">≥80 分</div>
        <div class="col-span-3 h-full flex items-center justify-center border-solid border-black gap-0">不少于 10 个应用场景（其中不少于 6 个约束性场景）等级需达到四级</div>
      </div>
      <p class="text-segment text-sm font-kaiti">备注：如企业无法满足最低级（一级）相关要求，则归类为<span class="font-heiti">无等级</span>。</p>
    </div>
  </div>
</template>
<script>
// 总览
export default {
  props: ['info']
}
</script>
